@for (step of steps; track step.step) {
  <section class="ticket-extras-step" data-testid="ticket-extras-step">
    <small class="d-block mb-2">{{ step.label || ('tickets.improve_experience' | transloco) }}</small>
    @for (supplement of step.supplements; track supplement.id) {
      <div class="combi-item w-100">
        <div class="row no-gutters w-100 no-wrap">
          <div class="d-flex">
            @if (supplement.image) {
              <div class="img-thumbnail">
                <img width="56" height="56" [ngSrc]="supplement.image | plysResize: 56 : 56" [alt]="supplement.name" />
              </div>
            }
            <div>
              <h6 class="text-sm mb-1 mr-2">
                {{ supplement.name }}
                @if (isMenuVisible(supplement) && menuUrl$ | async; as url) {
                  <a [href]="url" target="_blank" class="menu desktop">
                    <span class="meal-icon" inlineSVG="/assets/icons/meal.svg"></span>
                    {{ 'global.menu' | transloco }}
                  </a>
                }
              </h6>
              <div class="d-flex align-items-center">
                <strong class="text-base pr-1">+ {{ supplement.price | localeCurrency: supplement.currency }}</strong>
                <small class="text-xs color-small">{{ 'tickets.per_ticket' | transloco }}</small>
              </div>
              <ng-container
                *ngTemplateOutlet="description; context: { supplement: supplement, extraClass: 'desktop' }"
              ></ng-container>
            </div>
          </div>
          <div class="combi-quantity mt-3 quantity-control-container">
            @if (hasOptions(supplement)) {
              <!-- One per ticket and every ticket has one: nothing left to add, so no Add. -->
              @if ((canAddMore(supplement) | async) === true) {
                <plys-options-quantity
                  size="sm"
                  [product]="supplement"
                  (add)="openOptions(supplement, step.supplements)"
                ></plys-options-quantity>
              }
            } @else {
              <plys-quantity-control
                size="sm"
                [min]="1"
                [max]="maxQuantity(supplement) | async"
                [value]="quantity(supplement) | async"
                [addLabel]="'product_options.add' | transloco"
                [addTestId]="'add-' + supplement.name"
                [soldOutLabel]="supplement.soldOut ? ('product_options.sold_out' | transloco) : null"
                (increased)="add(supplement, step.supplements)"
                (decreased)="remove(supplement)"
                [displayLoading]="reserving$ | async"
              >
                @if (isMenuVisible(supplement) && menuUrl$ | async; as url) {
                  <a [href]="url" target="_blank" class="menu mobile-flex">
                    <span class="meal-icon" inlineSVG="/assets/icons/meal.svg"></span>
                  </a>
                }
              </plys-quantity-control>
            }
          </div>
        </div>
        @if (hasOptions(supplement)) {
          <plys-configured-items
            [product]="supplement"
            [parentProductId]="product.id"
            [siblings]="step.supplements"
            [ticket]="ticket"
            [ticketLineId]="ticketLineId"
          ></plys-configured-items>
        }
        <ng-container
          *ngTemplateOutlet="description; context: { supplement: supplement, extraClass: 'mobile' }"
        ></ng-container>
      </div>
    }
  </section>
}

<ng-template #description let-supplement="supplement" let-extraClass="extraClass">
  @if (isExpanded(supplement.id)) {
    <div class="description" [ngClass]="extraClass">
      {{ supplement.description }}
    </div>
  }
  @if (supplement.description) {
    <p class="read-details" [ngClass]="extraClass" (click)="toggleDetails(supplement.id)">
      {{ 'global.read_details' | transloco }}
      <span
        [class.expanded]="isExpanded(supplement.id)"
        class="read-details-icon"
        [inlineSVG]="'/assets/icons/icon-chevron-down-thick.svg'"
      ></span>
    </p>
  }
</ng-template>
